import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import _ from "lodash"

import Loading from "../../../common/Loading"
import CommonApprovalDisplay from "../../../common/CommonApprovalDisplay"

import { insertApprovalInstances } from "../../../services/api/approvalInstances"

import { raiseToast } from "../../../services/redux/reducers/toast/toast"

import { getApproverDetails } from "../../../utils"

import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig"


const NewApprovalsDisplay = (props) => {
    const {
        buyerPO,
        buyerPOItems,
        approvalTypes,
        approvalInstances,
        POApprovals,
        materialDetails,
        approvalRequestStatusDetails,
        setApprovalRequestStatusDetails,
        isDoc,
        handleRemarks,
        handleApprovalRequest,
        buyerPOId,
        buyerQuote,
        approvalSecondary,
        buyerSideFlag
    } = props

    const [raiseReqLoading, setRaiseReqLoading] = useState(false)

    const dispatch = useDispatch()
    const userDetails = useSelector((state) => state.userDetails)
    
    const pmCompanyConfig = getPMCompanyConfig(buyerPO.pmCompanyId)
    let currencyShortName = pmCompanyConfig.currencyShortName

    const handleApprovalRemarks = (id, text) => {
        handleRemarks(id, text)
    }

    const handleApproverChange = (srNo, userId) => {
        const updatedApprovalRequestStatusDetails = approvalRequestStatusDetails.map(eachRequestDetail => {
            if (eachRequestDetail.srNo === srNo) {
                return { ...eachRequestDetail, notifyToUserId: userId }
            }
            return eachRequestDetail
        })

        setApprovalRequestStatusDetails(updatedApprovalRequestStatusDetails)
    }

    const handleRaiseReq = async (displayApproval) => {
        if(!displayApproval.remarks){
            return dispatch(raiseToast({severity:'error', detail: "Please enter remarks!", life: 3000}))
        }
       
        const relatedApproval = POApprovals.find(eachApproval => eachApproval.approvalId === displayApproval.approvalId)
        if (relatedApproval.config?.isUploadFileMandatory && !displayApproval.uploadFile){
            return dispatch(raiseToast({severity:'error', detail: "Please Upload document!", life: 3000}))
        }
        
        setRaiseReqLoading(true)

        const newApprovalReq = {
            ...displayApproval, 
            approvalInstanceId: undefined, 
            statusId: 12, 
            docNo: buyerPO.docNo, 
            parentDocNo: buyerQuote[0].docNo, 
            buyerCompanyId: buyerQuote[0].companyId, 
            docTypeId: 14, 
            docId: buyerPOId, 
            pmBranchId: [26, 30].includes(displayApproval.approvalTypeId) ? null : buyerPO.pmBranchId,
            companyBranchId: buyerPO.branchId,
            createdBy: userDetails.userId,
            uploadFile: displayApproval.uploadFile,
            processedBy: null,
            processedAt: null,
            processedRemarks: null
        }

        if (window.confirm("Do you want to raise an approval request..?")){
            const newApprovalInstanceRes = await insertApprovalInstances({ requestedApprovals: [newApprovalReq] })
            if(newApprovalInstanceRes.failure){
                setRaiseReqLoading(false)
                return dispatch(raiseToast({severity:'error', summary:'Approval Instance', detail: newApprovalInstanceRes.data.error, life: 3000}))
            }
            setRaiseReqLoading(false)

            handleApprovalRequest({...newApprovalInstanceRes.data[0], srNo: displayApproval.srNo, requestStatus: "REQUESTED"})
        }else{
            setRaiseReqLoading(false)
        }
    }

    const getApprovalBody = (approvalTypeId, products) => {
        switch (approvalTypeId){
            case 14:
                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">PRODUCTS</th>
                                    <th className="">PRICE BEFORE TAX</th>
                                    <th className="">TOTAL TAX</th>
                                    <th className="">GRAND TOTAL</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                    <td className="">{products.join(', ')}</td>
                                    <td className="">{currencyShortName}.{buyerPO?.bPOTotalAmountBeforeTax}</td>
                                    <td className="">{currencyShortName}.{buyerPO?.bPOTotalTax}</td>
                                    <td className="">{currencyShortName}.{buyerPO?.bPOTotalAmountWithTax}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 22:
                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">PRODUCTS</th>
                                    <th className="">PRICE BEFORE TAX</th>
                                    <th className="">TOTAL TAX</th>
                                    <th className="">GRAND TOTAL</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                    <td className="">{products.join(', ')}</td>
                                    <td className="">{currencyShortName}.{buyerPO?.bPOTotalAmountBeforeTax}</td>
                                    <td className="">{currencyShortName}.{buyerPO?.bPOTotalTax}</td>
                                    <td className="">{currencyShortName}.{buyerPO?.bPOTotalAmountWithTax}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 26:
                return (
                    <div className="custom-table-container">
                        <table className="custom-product-table" style={{ width: "100%" }}>
                            <thead >
                                <tr className="">
                                    <th className="">PRODUCTS</th>
                                    <th className="">PRICE BEFORE TAX</th>
                                    <th className="">TOTAL TAX</th>
                                    <th className="">GRAND TOTAL</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                    <td className="">{products.join(', ')}</td>
                                    <td className="">{currencyShortName}.{buyerPO?.bPOTotalAmountBeforeTax}</td>
                                    <td className="">{currencyShortName}.{buyerPO?.bPOTotalTax}</td>
                                    <td className="">{currencyShortName}.{buyerPO?.bPOTotalAmountWithTax}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                )
                break
            case 30:
                    return (
                        <div className="custom-table-container">
                            <table className="custom-product-table" style={{ width: "100%" }}>
                                <thead >
                                    <tr className="">
                                        <th className="">PRODUCTS</th>
                                        <th className="">PRICE BEFORE TAX</th>
                                        <th className="">TOTAL TAX</th>
                                        <th className="">GRAND TOTAL</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                                    <tr className="" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                        <td className="">{products.join(', ')}</td>
                                        <td className="">{currencyShortName}.{buyerPO?.bPOTotalAmountBeforeTax}</td>
                                        <td className="">{currencyShortName}.{buyerPO?.bPOTotalTax}</td>
                                        <td className="">{currencyShortName}.{buyerPO?.bPOTotalAmountWithTax}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )
                    break
            default:
                return null
        }

    }

    const renderApprovals = (buyerPOItems, approvalInstances, POApprovals, approvalRequestStatusDetails) => {
        let pmCompanyUsers = userDetails?.PMCompanyDetails?.companyUsers ? userDetails?.PMCompanyDetails?.companyUsers : []
        let pmCompanyRoles = userDetails?.PMCompanyDetails?.companyRoles ? userDetails?.PMCompanyDetails?.companyRoles : []
        let pmBranches = userDetails?.PMCompanyDetails?.companyBranches ? userDetails?.PMCompanyDetails?.companyBranches : []

        if (userDetails.PMCompanyDetails.companyId !== userDetails.companyDetails.companyId){
            pmCompanyUsers = [...pmCompanyUsers, ...userDetails.companyDetails.companyUsers]
            pmCompanyRoles = [...pmCompanyRoles, ...userDetails.companyDetails.companyRoles]
            pmBranches = [...pmBranches, ...userDetails.companyDetails.companyBranches]
        }

        const updatedApprovalInstances = approvalInstances.map(eachApprovalInstance => {
            const relatedApproval = POApprovals?.find(eachPOApproval => eachPOApproval.approvalId === eachApprovalInstance.approvalId)
            eachApprovalInstance.approvalTypeId = relatedApproval.approvalTypeId
            return eachApprovalInstance
        })

        return approvalRequestStatusDetails.map((eachRequestDetail, index) => {
            const relatedPOApproval = POApprovals.find(eachQuoteApproval => eachQuoteApproval.approvalId === eachRequestDetail.approvalId)
            const relatedApprovalType = approvalTypes.find(eachApprovalType => eachApprovalType.approvalTypeId === relatedPOApproval.approvalTypeId)
    
            let approvedOrRejectedBy = ""
            if(["REJECTED", "APPROVED"].includes(eachRequestDetail.requestStatus)){
                approvedOrRejectedBy = pmCompanyUsers.find(eachUser => eachUser.userId === eachRequestDetail.processedBy)
            }
            let products = []
            buyerPOItems.map(eachPOItem => {
                materialDetails.forEach(eachMaterial => {
                    if (eachPOItem.materialId === eachMaterial.materialId) {
                        products.push(eachMaterial.productName)
                    }
                })
            })

            let createdBy = eachRequestDetail.createdBy ? eachRequestDetail.createdBy : userDetails?.userId
            const primaryApprover = getApproverDetails(relatedPOApproval, buyerPO.pmBranchId, createdBy, pmCompanyUsers, pmCompanyRoles, pmBranches, approvalSecondary)

            let relatedHistoryRequests = updatedApprovalInstances.filter(eachReq => eachReq.approvalId === relatedPOApproval.approvalId && eachReq.approvalInstanceId && eachReq.approvalInstanceId !== eachRequestDetail.approvalInstanceId)

            let approvalBody = getApprovalBody(relatedPOApproval.approvalTypeId, products)

            let isRequestRestricted = false
            if ([26, 30].includes(relatedApprovalType.approvalTypeId) && !buyerSideFlag){
                isRequestRestricted = true
            }

            return (
                <CommonApprovalDisplay
                    approvalBody={approvalBody}
                    index={index}
                    approvalType={relatedApprovalType}
                    approval={relatedPOApproval}
                    isDoc={isDoc}
                    primaryApprover={primaryApprover}
                    handleRaiseReq={handleRaiseReq}
                    handleApprovalRemarks={handleApprovalRemarks}
                    handleApproverChange={handleApproverChange}
                    eachRequestDetail={eachRequestDetail}
                    approvalRequestStatusDetails={approvalRequestStatusDetails}
                    setApprovalRequestStatusDetails={setApprovalRequestStatusDetails}
                    historyRequests={relatedHistoryRequests}
                    approvedOrRejectedBy={approvedOrRejectedBy}
                    isRequestRestricted={isRequestRestricted}
                />
            )
            
        })
    }

    return (
        <div className="approval-modal">
            <Loading visible={raiseReqLoading} />
            {renderApprovals(buyerPOItems, approvalInstances, POApprovals, approvalRequestStatusDetails)}
        </div>
    )
}

export default NewApprovalsDisplay